import styled from "styled-components";

export const TableRelacionMT = styled.table`
    margin: 10px 50px;

    th {
        background-color: ${({theme}:any) => theme.btn?.primary.background};
        padding: 5px 10px;
        :nth-child(1){
            border-radius: 10px 0px 0px 10px;
        }
        :last-child{
            border-radius: 0px 10px 10px 0px; 
        }
    }
    tbody {
         tr {
            border-bottom: solid 1px;
            border-color: ${({theme}:any) => theme.btn?.primary.background};
        }
        
    }
    td {
        padding: 0px 10px;
    }
`

export const ContainerTOperaciones = styled.div<any>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

export const RowsMT = styled.div<any>`
    margin: 20px;


`